import {
  Id,
  Request,
  RequestHistory,
  RequestTicket,
  RequestToClassify
} from 'src/types'
import Api, { make, Response } from 'src/services/api'
import { ResponseDataRequests } from 'src/core/store/ducks/requests/types'

interface GetRequestHistoryProps {
  request_id: Id
  user_id: Id
}

interface GetRequestHistoryResponse {
  request_history: RequestHistory[]
}

type GetRequestProps = {
  organization_id: Id
}

type GetRequestsToClassifyProps = {
  organization_id: Id
  user_id: Id
}

export function GetRequestHistory({
  user_id,
  request_id
}: GetRequestHistoryProps): Promise<Response<GetRequestHistoryResponse>> {
  return make<GetRequestHistoryResponse>({
    axiosCall: Api.get(`users/${user_id}/request/${request_id}/history`)
  })
}

export function GetRequestsInUnderway({
  organization_id
}: GetRequestProps): Promise<Response<ResponseDataRequests>> {
  return make<ResponseDataRequests>({
    axiosCall: Api.get(
      `organizations/${organization_id}/requests?page_size=100&page=1&underway=TRUE`
    )
  })
}

export function GetRequestsToClassify({
  organization_id,
  user_id
}: GetRequestsToClassifyProps): Promise<Response<RequestToClassify[]>> {
  const sendUser = user_id === 5871 ? '' : `users/${user_id}/`
  return make<RequestToClassify[]>({
    axiosCall: Api.get(
      `organizations/${organization_id}/${sendUser}get/mock_requests`
    )
  })
}

interface RequestErpCodeProps {
  erp_code: string
  organization_id: Id
  request_id: Id
}

export function SetRequestErpCode({
  erp_code,
  organization_id,
  request_id
}: RequestErpCodeProps): Promise<Response<Request>> {
  const url = `organizations/${organization_id}/erp/request`
  return make({
    axiosCall: Api.post(url, {
      data: { request_id, erp_code }
    })
  })
}

interface InativeRequestProps {
  organization_id: Id
  request_id: Id
}

export function InativeRequest({
  organization_id,
  request_id
}: InativeRequestProps): Promise<Response<RequestToClassify[]>> {
  const url = `organizations/${organization_id}/save/request`
  return make({
    axiosCall: Api.post(url, {
      data: { request_id, active: false }
    })
  })
}
interface Props {
  organization_id: Id
  request_id: Id
}

interface SaveObservationRequestProps extends Props {
  obs: string
}

interface SaveTitleRequestProps extends Props {
  title: string
}
export function SaveObservationRequest({
  obs,
  organization_id,
  request_id
}: SaveObservationRequestProps): Promise<Response<Request[]>> {
  const url = `organizations/${organization_id}/obs/request`
  return make({ axiosCall: Api.post(url, { data: { obs, request_id } }) })
}

export function SaveTitleRequest({
  title,
  organization_id,
  request_id
}: SaveTitleRequestProps): Promise<Response<Request[]>> {
  const url = `organizations/${organization_id}/title/request`
  return make({ axiosCall: Api.post(url, { data: { title, request_id } }) })
}

interface UpdateRequestStatusSincProps {
  integration: string
  organizationId: Id
  request_number: string
}

export function updateRequestStatusSinc({
  integration,
  organizationId,
  request_number
}: UpdateRequestStatusSincProps): Promise<Response<RequestTicket[]>> {
  const url = `organizations/${organizationId}/ticket_status/request`
  return make({
    axiosCall: Api.post(url, {
      data: { request_number, sync_status: integration }
    })
  })
}

export function deleteRequestsToClassify({
  request_base_id,
  organization_id
}: {
  request_base_id: Id
  organization_id: Id
}): Promise<any> {
  const url = `/organizations/${organization_id}/mock_request/${request_base_id}`
  return make({ axiosCall: Api.post(url) })
}
